import { getApplicationSettings } from "owa-application-settings";
import type { MailboxInfo } from "owa-client-types";
import { isOfflinePeopleDataViaPDVEnabled } from "./isOfflinePeopleDataViaPDVEnabled";

export const isServerFirstPersonResolutionEnabled = (mailboxInfo: MailboxInfo): boolean => {
    const { enableServerFirstPersonResolution, enabled } = getApplicationSettings("OnePersonView");
    return (enabled &&
        enableServerFirstPersonResolution &&
        isOfflinePeopleDataViaPDVEnabled(mailboxInfo));
};
